import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSipTrunkingNotSupported = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.16695 9.625H5L5.00041 7.75H9.16695V4.00081L10.0001 4L11.25 4.00081V7.75H15.0004L15 8.375V9.625H11.25V12.75H15.0002L15 14.625H11.25V16.5C10.625 16.5 11.692 16.5 11.25 16.5C11.25 17.125 11.25 17.308 11.25 17.75H10.0001H9.16695C9.16695 17.308 9.16695 17.125 9.16695 16.5C8.72492 16.5 9.79196 16.5 9.16695 16.5V14.625H5.00041L5 12.75H9.16695V9.625Z",
		fill: "#475467"
	})]
});
const ForwardRef = forwardRef(SvgSipTrunkingNotSupported);
export { ForwardRef as ReactComponent };
